import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroPlanes = async (fechaStart,fechaEnd , tipoSolicitud,estado) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/registroplanes?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idPlan=${tipoSolicitud}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRegistroPlanesEstado = async (estado, idRecolector) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/registroplanes/estado?empresa=${userInfo.empresa}&estado=${estado}&rol=${userInfo.rol}&idRecolector=${idRecolector}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRegistroPlanesId = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/registroplanes/id?empresa=${userInfo.empresa}&idCliente=${userInfo.usuario}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRegistroPlanesRut = async (rutCliPro) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/registroplanes/rut?empresa=${userInfo.empresa}&rutCliPro=${rutCliPro}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroPlanCliente = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/registroplanes/creacliente', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const crearRegistroPlan = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/registroplanes', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const modificaRegistroPlan = async (clienteData) => {
    try {        
        const {data}  = await Axios.post(
            '/registroplanes/cambioplan', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroPlan = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/registroplanes/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroPlan = (Id) => Axios.delete(`/registroplanes/${Id}`);